import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
export const ReduxInitLoadable = ()=>{
    const mounted = useIsMounted();
    return mounted ? /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getModule()
        ]
    }) : null;
};
ReduxInitLoadable.displayName = 'TierConsumerReduxLoadable';
export default ReduxInitLoadable;

//# sourceMappingURL=ModuleLoadable.js.map